/**
 * The policy pages: terms, privacy, refunds.
 *
 * One narrow column of prose inside the same shell as every other page, so the
 * language switch, the wordmark and the footer — with the registered business
 * details and governing law — stay where a visitor left them. Card acquirers
 * require these pages to exist and to be reachable; a reader arriving from an
 * invoice should find them readable too.
 */

import { h } from '../lib/dom.js';
import { LEGAL, PAGES } from '../legal.js';
import { routeLink } from './chrome.js';

export function renderLegal(lang, page) {
  const l = LEGAL[lang];
  const doc = l[page];

  return h(
    'article',
    { class: 'legal' },
    h('h1', { class: 'legal-title' }, doc.title),
    h('p', { class: 'legal-updated' }, `${l.updated} ${l.updatedDate}`),
    ...doc.sections.map(([heading, paragraphs]) =>
      h('section', { class: 'legal-section' }, h('h2', null, heading), ...paragraphs.map((text) => h('p', null, text))),
    ),
    details(l),
    h('hr', { class: 'hr', style: 'margin: 40px 0 0' }),
    // The footer links every policy too, but a reader who reaches the end of
    // one should not have to scroll past it to find the next.
    h(
      'p',
      { class: 'legal-back' },
      routeLink(lang, null, l.back),
      ...PAGES.filter((other) => other !== page).flatMap((other) => [' · ', routeLink(lang, other, l.nav[other])]),
    ),
  );
}

/**
 * The registered name, number and address, on every policy page rather than
 * only one — an acquirer checking the site should not have to hunt for them,
 * and nor should a client.
 */
function details(l) {
  return h(
    'section',
    { class: 'legal-section legal-details' },
    h('h2', null, l.details.title),
    h('dl', { class: 'legal-dl' }, ...l.details.rows.flatMap(([label, value]) => [h('dt', null, label), h('dd', null, value)])),
  );
}
